import { InterfaceLimitationEnum } from '../enums/InterfaceLimitationEnum';
import { UserRoleEnum } from '../enums/UserRoleEnum';
import type RouterPage from '../interfaces/RouterPage';
import type RouterPageContext from '../interfaces/RouterPageContext';
import { translate } from './translation';
import { hasInterfaceLimitation } from './utils';

export const routerPages: RouterPage[] = [
  {
    hasDivider: false,
    href: '/files/personal',
    icon: 'FolderIcon',
    isDisabled: false,
    isHidden: false,
    key: 'files',
    label: translate('common.files'),
    notificationsCount: 0,
    condition: (context) => {
      return !hasInterfaceLimitation(
        context.authenticatedUser?.settings || [],
        InterfaceLimitationEnum.DenyShowFiles,
      );
    },
  },
  {
    hasDivider: false,
    href: '/files/received',
    icon: 'FileDownIcon',
    isDisabled: false,
    isHidden: false,
    key: 'received',
    label: translate('common.received'),
    notificationsCount: 0,
    condition: (context) => {
      return !hasInterfaceLimitation(
        context.authenticatedUser?.settings || [],
        InterfaceLimitationEnum.DenyShowReceived,
      );
    },
  },
  {
    hasDivider: false,
    href: '/files/shared',
    icon: 'FileUserIcon',
    isDisabled: false,
    isHidden: false,
    key: 'shared',
    label: translate('common.shared'),
    notificationsCount: 0,
    condition: (context) => {
      return !hasInterfaceLimitation(
        context.authenticatedUser?.settings || [],
        InterfaceLimitationEnum.DenyShowShared,
      );
    },
  },
  {
    hasDivider: false,
    href: '/files/favorites',
    icon: 'StarIcon',
    isDisabled: false,
    isHidden: false,
    key: 'favorites',
    label: translate('common.favorites'),
    notificationsCount: 0,
    condition: (context) => {
      return !hasInterfaceLimitation(
        context.authenticatedUser?.settings || [],
        InterfaceLimitationEnum.DenyShowFavorites,
      );
    },
  },
  {
    hasDivider: false,
    href: '/files/hidden',
    icon: 'ArchiveIcon',
    isDisabled: false,
    isHidden: false,
    key: 'archive',
    label: translate('common.hidden'),
    notificationsCount: 0,
    condition: (context) => {
      return !hasInterfaceLimitation(
        context.authenticatedUser?.settings || [],
        InterfaceLimitationEnum.DenyShowHidden,
      );
    },
  },
  {
    hasDivider: true,
    href: '/files/trash',
    icon: 'TrashIcon',
    isDisabled: false,
    isHidden: false,
    key: 'trash',
    label: translate('common.trash'),
    notificationsCount: 0,
    condition: (context) => {
      return !hasInterfaceLimitation(
        context.authenticatedUser?.settings || [],
        InterfaceLimitationEnum.DenyShowTrash,
      );
    },
  },
  {
    hasDivider: false,
    href: '/users',
    icon: 'UserIcon',
    isDisabled: false,
    isHidden: false,
    key: 'users',
    label: translate('common.users'),
    notificationsCount: 0,
    condition: (context) => {
      return !hasInterfaceLimitation(
        context.authenticatedUser?.settings || [],
        InterfaceLimitationEnum.DenyShowUsers,
      );
    },
  },
  {
    hasDivider: true,
    href: '/groups',
    icon: 'UsersIcon',
    isDisabled: false,
    isHidden: false,
    key: 'groups',
    label: translate('common.groups'),
    notificationsCount: 0,
    condition: (context) => {
      return !hasInterfaceLimitation(
        context.authenticatedUser?.settings || [],
        InterfaceLimitationEnum.DenyShowGroups,
      );
    },
  },
  {
    hasDivider: false,
    href: '/activity-logs',
    icon: 'LogsIcon',
    isDisabled: false,
    isHidden: false,
    key: 'activity-log',
    label: translate('common.activityLog'),
    notificationsCount: 0,
    condition: (context) => {
      return !hasInterfaceLimitation(
        context.authenticatedUser?.settings || [],
        InterfaceLimitationEnum.DenyShowActivities,
      );
    },
  },
  {
    hasDivider: true,
    href: '/sales-dashboard',
    icon: 'StoreIcon',
    isDisabled: false,
    isHidden: false,
    key: 'sales-dashboard',
    label: translate('store.salesDashboard'),
    notificationsCount: 0,
    condition: (context) => {
      return (
        [UserRoleEnum.Admin].includes(context.authenticatedUser?.role || UserRoleEnum.Reader) &&
        import.meta.env.VITE_APP_STORE_ENABLED === 'true' &&
        (context.authenticatedUser?.isSellEnabled || false)
      );
    },
  },
  {
    hasDivider: true,
    href: '/settings',
    icon: 'SettingsIcon',
    isDisabled: false,
    isHidden: false,
    key: 'settings',
    label: translate('common.settings'),
    notificationsCount: 0,
    condition: (context) => {
      return !hasInterfaceLimitation(
        context.authenticatedUser?.settings || [],
        InterfaceLimitationEnum.DenyShowSettings,
      );
    },
  },
];

export function filteredRouterPages(context: RouterPageContext): RouterPage[] {
  return routerPages.filter((page) => {
    if (page.condition) {
      return page.condition(context);
    }
    return true;
  });
}
